import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
    {
        path: '/aistorymap',
        name: 'aistorymap',
        props: () => ({
            kind: AiStorymapKind.Storymap,
        }),
        component: () => import(/* webpackChunkName: "aiStorymap" */ '../pages/aiStorymap/AiStorymap.vue'),
    },
    {
        path: '/aiuserstory',
        name: 'aiuserstory',
        props: () => ({
            kind: AiStorymapKind.UserStories,
        }),
        component: () => import(/* webpackChunkName: "aiStorymap" */ '../pages/aiStorymap/AiStorymap.vue'),
    },
];

routes.push({
    path: '*',
    component: () => import(/* webpackChunkName: "PageNotFound" */ '@/PageNotFound.vue'),
});

const router = new VueRouter({
    mode: 'history',
    //base: process.env.BASE_URL,
    routes,
});

let lastPage: Route = null;
router.afterEach((to, from) => {
    lastPage = from;
});

export const goBack = () => {
    if (lastPage != null && lastPage != router.currentRoute) {
        router.push(lastPage.fullPath);
    } else {
        router.push('/');
    }
};

export enum AiStorymapKind {
    Storymap = 1,
    UserStories = 2,
}

export default router;
